import { ImportFileWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('ImportFile')
export class ImportFileNodeConnectorProvider extends ConnectorProvider<ImportFileWorkflowNode> {}
